import { Button, Card, Input, Popconfirm, Tooltip } from "antd";
import React, { useContext } from "react";
import useGroupViewPresenter from "../../presentation/hooks/useGroupViewPresenter";
import { ArrowBackIos } from "@mui/icons-material";
import GroupsTable from "./GroupsTable";
import UsersTable from "./UsersTable";
import { getSystemId } from "@Totum/Main/Utils";
import { GroupContext, SystemContext } from "@Totum/Main/Constants";
import AssignmentMenu from "./GroupsAssignmentMenu";
import useAssignmentMenuOperations from "@Totum/Groups/Application/hooks/useAssignmentMenuOperations";
import { MainContext } from "@Totum/Main/Context/provider";
import { CloseCircleFilled } from "@ant-design/icons";
import { ActiveTabKey } from "@Totum/Groups/Constants";

const GroupsList = () => {
    const { handlers, uiModel } = useGroupViewPresenter();
    const { addAction } = useAssignmentMenuOperations();
    const { setCurrentGroup, setCurrentUser } = useContext(MainContext);

    const GroupsAssignmentMenu = () => {
        return (
            <>
                {uiModel.activeTabKey === ActiveTabKey.Groups ? (
                    <AssignmentMenu
                        roleAssignments={[]}
                        creditAssignments={
                            uiModel.isRootGroupView
                                ? []
                                : uiModel.groupCredits.filter(
                                      (x) => x.contextId === GroupContext && x.instanceId === uiModel.currentGroupId
                                  )
                        }
                        context={uiModel.isRootGroupView ? SystemContext : GroupContext}
                        groupId={uiModel.isRootGroupView ? getSystemId() : uiModel.currentGroupId}
                        page={0}
                        userId={""}
                        addAction={addAction}
                        systemRolesOnly={false}
                    />
                ) : null}
            </>
        );
    };

    return (
        <Card
            className="groups-list"
            tabList={uiModel.isRootGroupView ? uiModel.tabList : undefined}
            onTabChange={(key) => {
                handlers.handleTabChange(key);
            }}
            tabBarExtraContent={uiModel.canCreateRootGroups ? <GroupsAssignmentMenu /> : null}
        >
            <div className="subgroup-header">
                {uiModel.currentGroup?.name ? (
                    <div style={{ display: "flex" }}>
                        <Button
                            className="back-button"
                            onClick={() => {
                                handlers.handleGroupBack();
                            }}
                        >
                            <ArrowBackIos />
                        </Button>
                        <Button
                            className="back-button"
                            onClick={() => {
                                setCurrentGroup({ instance: uiModel.currentGroupId });
                                setCurrentUser(null);
                            }}
                        >
                            {uiModel.currentGroup?.name}
                        </Button>
                    </div>
                ) : null}
                {uiModel.isRootGroupView ? null : (
                    <div className="assignment-menu">
                        {uiModel.canAddToGroups ? <GroupsAssignmentMenu /> : null}
                        {uiModel.allowRemove && uiModel.canRemoveBase ? (
                            <Tooltip title="Delete group">
                                <Popconfirm
                                    title={"Delete this group and all child groups? This cannot be undone."}
                                    onConfirm={() => {
                                        handlers.handleDeleteGroup();
                                    }}
                                    okText="Yes"
                                    cancelText="No"
                                    cancelButtonProps={{ className: "secondary" }}
                                >
                                    <button className={"no-style"}>
                                        <CloseCircleFilled />
                                    </button>
                                </Popconfirm>
                            </Tooltip>
                        ) : null}
                    </div>
                )}
            </div>

            <Input
                value={uiModel.searchTerm}
                placeholder={uiModel.isRootGroupView ? `Search ${uiModel.activeTabKey}` : "Search groups/users"}
                style={{ width: "100%", marginBottom: "20px" }}
                onChange={(e) => handlers.handleSearchInputChange(e.target.value)}
                allowClear={true}
            />
            {(!uiModel.isRootGroupView && !uiModel.userGroup.length && !uiModel.isFetchingUserGroup) ||
            !(uiModel.activeTabKey === ActiveTabKey.Groups) ? null : (
                <GroupsTable
                    searchTerm={uiModel.debouncedSearchTerm}
                    isFetching={uiModel.isFetchingUserGroups || uiModel.isFetchingUserGroup}
                    userGroupData={uiModel.isRootGroupView ? uiModel.userGroups : uiModel.userGroup}
                    currentPage={uiModel.groupsCurrentPage}
                    handlePageChange={handlers.handleGroupsTablePageChange}
                    handleGroupSelect={handlers.handleGroupSelect}
                />
            )}
            {!uiModel.isRootGroupView || uiModel.activeTabKey === ActiveTabKey.Users ? (
                <UsersTable
                    searchTerm={uiModel.debouncedSearchTerm}
                    activeTabKey={uiModel.activeTabKey}
                    currentPage={uiModel.usersCurrentPage}
                    handlePageChange={handlers.handleUsersTablePageChange}
                    isRootGroupView={uiModel.isRootGroupView}
                />
            ) : null}
        </Card>
    );
};

export default GroupsList;
